import { useCallback, useEffect, useState, useRef } from 'react';

import { useChatClient } from '@bizzabo/chat-core';

const useMessagesNotification = () => {
    const { client } = useChatClient();
    const [unreadMessagesCount, setUnreadMessagesCount] = useState<number | unknown>(0);

    const clientListener = useRef(null);

    const listenerToEvents = useCallback(() => {
        clientListener.current = client.on(event => {
            const isPrivateChannel = event.channel_type === 'private';
            const isNewMessage =
                event.type === 'notification.message_new' || event.type === 'message.new';
            const isMessageRead = event.type === 'notification.mark_read';

            if (isPrivateChannel && (isNewMessage || isMessageRead)) {
                setUnreadMessagesCount(event.unread_count);
            }
        });
    }, [client, setUnreadMessagesCount]);

    useEffect(() => {
        if (!client) {
            return;
        }
        if (client.user.total_unread_count) {
            setUnreadMessagesCount(client.user.total_unread_count);
        }
        listenerToEvents();
        return () => {
            clientListener.current?.unsubscribe();
        };
    }, [client, listenerToEvents, setUnreadMessagesCount]);

    const resetNotification = () => {
        setUnreadMessagesCount(0);
    };

    const hasNewNotification = unreadMessagesCount > 0;

    return {
        hasNewNotification,
        unreadMessagesCount,
        resetNotification,
        shouldResetNotificationOnSelect: true,
    };
};

export default useMessagesNotification;
